import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { DOCUMENT_TYPES } from "../../constants/enums/document-types";
import {
    emailRegex,
    onlyNumericRegex,
    phoneRegex,
} from "../../constants/regex";
import {
    MAX_MONTHLY_AMOUNT,
    MIN_MONTHLY_AMOUNT,
} from "../../constants/amounts";
import { QuotationPopupFormModelRaw } from "./types/quotation-popup";

export const quotationPopupFormSchema = yup.object<
    Record<keyof QuotationPopupFormModelRaw, yup.AnySchema>
>({
    documentType: yup
        .string()
        .required("Tipo documento requerido")
        .oneOf([DOCUMENT_TYPES.RUC], "Tipo documento inválido"),
    documentNumber: yup
        .string()
        .required("RUC requerido")
        .matches(onlyNumericRegex, "RUC inválido")
        .length(11, "RUC inválido")
        .test("invalidDoc", "RUC no válido", (val) =>
            !val ? true : val.startsWith("10") || val.startsWith("20")
        ),
    monthlyAmount: yup
        .string()
        .required("Monto requerido")
        .transform((val: string) => val.replace("S/", "").replace(/ /g, ""))
        .test(
            "minAmount",
            `Monto mínimo es ${MIN_MONTHLY_AMOUNT}`,
            (val: string) =>
                isNaN(Number(val)) ? true : Number(val) >= MIN_MONTHLY_AMOUNT
        )
        .test("maxAmount", "Monto mensual no válido", (val: string) =>
            isNaN(Number(val)) ? true : Number(val) <= MAX_MONTHLY_AMOUNT
        ),
    rangeOfEmployees: yup.string().required("Rango requerido"),
    yesNo: yup.bool(),
    employeesHaveValidAge: yup.bool().oneOf([true]),
    termsAndConditions: yup.bool().oneOf([true]),
    contactEmail: yup
        .string()
        .required("Email requerido")
        .matches(emailRegex, "Email inválido"),
    contactNames: yup
        .string()
        .required("Nombres requeridos")
        .min(5, "Mínimo 5 caracteres"),
    contactPhone: yup
        .string()
        .required("Teléfono requerido")
        .matches(phoneRegex, "Teléfono inválido"),
});

export const quotationPopupFormResolver = yupResolver(quotationPopupFormSchema);
